import { Title } from "../../../../Wrap/Constants/Enums/Title";

export class TitleMap {
    public static getString(Title: Title): string {
        if (!Title) {return null;}
        return this.getMap().get(Title);
    }

    public static getEnum(Title: string): Title {
        const map = this.getMap();

        let result: Title;
        map.forEach((value: string, index: Title) => {
            if (value === Title) {
                result = index;
            }
        });

        return result;
    }

    public static getArray(): Title[] {
        const options = [];
        options.push(Title.Mr);
        options.push(Title.Mrs);
        options.push(Title.Miss);
        options.push(Title.Ms);
        options.push(Title.Dr);
        options.push(Title.AssocProfessor);
        options.push(Title.Captain);
        options.push(Title.Father);
        options.push(Title.Judge);
        options.push(Title.Justice);
        options.push(Title.Lady);
        options.push(Title.Madam);
        options.push(Title.Major);
        options.push(Title.Pastor);
        options.push(Title.Prof);
        options.push(Title.Rev);
        options.push(Title.Sir);
        options.push(Title.Dame);
        options.push(Title.Lord);
        options.push(Title.Sister);
        options.push(Title.TheHon);
        options.push(Title.Other);
        options.push(Title.Brigadier);
        options.push(Title.Baroness);
        options.push(Title.LtComm);
        options.push(Title.Colonel);
        options.push(Title.ExecutorsOf);
        options.push(Title.HisHonour);
        options.push(Title.Commodore);
        options.push(Title.Deacon);
        options.push(Title.TheRightHon);
        options.push(Title.TheRightHonLord);
        options.push(Title.RevPrebendary);
        options.push(Title.Mx);
        options.push(Title.Reverend);
        return options;
    }

    public static getTitleArrayAsString(): string[] {
        const options = [];
        options.push("Mr");
        options.push("Mrs");
        options.push("Miss");
        options.push("Ms");
        options.push("Dr");
        options.push("Assoc. Prof");
        options.push("Captain");
        options.push("Father");
        options.push("Judge");
        options.push("Justice");
        options.push("Lady");
        options.push("Madam");
        options.push("Major");
        options.push("Pastor");
        options.push("Prof");
        options.push("Rev");
        options.push("Sir");
        options.push("Dame");
        options.push("Lord");
        options.push("Sister");
        options.push("The Hon");
        options.push("Other");
        options.push("Brigadier");
        options.push("Baroness");
        options.push("Lieutenant Commander");
        options.push("Colonel");
        options.push("Executors of");
        options.push("His Honour");
        options.push("Commodore");
        options.push("Deacon");
        options.push("The Right Honourable");
        options.push("The Right Honourable Lord");
        options.push("Rev Prebendary");
        options.push("Mx");
        options.push("Reverend");

        return options;
    }

    private static getMap(): Map<Title, string> {
        const map = new Map<Title, string>();

        map.set(Title.NotSpecified, "Not Specified");
        map.set(Title.Mr, "Mr");
        map.set(Title.Mrs, "Mrs");
        map.set(Title.Miss, "Miss");
        map.set(Title.Ms, "Ms");
        map.set(Title.Dr, "Dr");
        map.set(Title.AssocProfessor, "Assoc. Prof");
        map.set(Title.Captain, "Captain");
        map.set(Title.Father, "Father");
        map.set(Title.Judge, "Judge");
        map.set(Title.Justice, "Justice");
        map.set(Title.Lady, "Lady");
        map.set(Title.Madam, "Madam");
        map.set(Title.Major, "Major");
        map.set(Title.Pastor, "Pastor");
        map.set(Title.Prof, "Prof");
        map.set(Title.Rev, "Rev");
        map.set(Title.Sir, "Sir");
        map.set(Title.Dame, "Dame");
        map.set(Title.Lord, "Lord");
        map.set(Title.Sister, "Sister");
        map.set(Title.TheHon, "The Hon");
        map.set(Title.Other, "Other");
        map.set(Title.Brigadier, "Brigadier");
        map.set(Title.Baroness, "Baroness");
        map.set(Title.LtComm, "Lt Comm");
        map.set(Title.Colonel, "Colonel");
        map.set(Title.ExecutorsOf, "Executors of");
        map.set(Title.HisHonour, "His Honour");
        map.set(Title.Commodore, "Commodore");
        map.set(Title.Deacon, "Deacon");
        map.set(Title.TheRightHon, "The Right Honourable");
        map.set(Title.TheRightHonLord, "The Right Honourable Lord");
        map.set(Title.RevPrebendary, "Rev Prebendary");
        map.set(Title.Mx, "Mx");
        map.set(Title.Reverend, "Reverend");

        return map;
    }
}
